<template>
  <InvestmentTransactionNavbar
    :close-button-aria-label="closeButtonLabel"
    is-back-button-visible
    @on-back="handleBackClick"
    @on-close="handleCloseClick"
  />
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { GtmTracker } from '@/modules/common/services/analytics';
import { PortfolioModule } from '@/store/modules/PortfolioModule';
import { InvestmentTransactionNavbar } from '@/modules/transaction/views/InvestmentTransaction/components/InvestmentTransactionNavbar';
import { PortfolioCategories } from '@/types/models/Portfolio';

@Component({
  name: 'InvestmentTransactionNavbarContainer',
  components: { InvestmentTransactionNavbar }
})
export default class InvestmentTransactionNavbarContainer extends Vue {
  @Prop({ type: String, required: true })
  private portfolioName!: string;

  private get closeButtonLabel() {
    return 'Voltar para sua carteira';
  }

  private get trackEvent() {
    return GtmTracker.trackerWithDefaultProps({
      category: 'PEX - Investir Carteira'
    });
  }

  private handleBackClick() {
    this.trackEvent({ action: 'Clique retornar', label: this.portfolioName });
    this.$router.back();
  }

  private handleCloseClick() {
    this.$router.push({
      name: 'wealthPortfolio',
      params: {
        id: this.$route.params.portfolio,
        type: PortfolioCategories.WarrenManagement
      }
    });
    PortfolioModule.resetInvestedPortfolios();
  }
}
</script>
